export default function NEWS() {
  const [w,d] = [window,document]
  w.addEventListener('DOMContentLoaded',()=>{
    // リスト・詳細コンテナのクラス変更
    const list_container = d.querySelector('.element_list')
    const detail_container = d.querySelector('.element_detail')
    if(list_container){
      list_container.classList.remove('element_list')
      list_container.classList.add('p-news__list')
    }
    if(detail_container){
      detail_container.classList.remove('element_detail')
      detail_container.classList.add('p-news__detail')
    }
    $('.paginationbox').appendTo('#container')

    // 記事リスト整形
    $('.artloop','.p-news__list').each((i,v)=>{
      const wrapLink = $(v).parent('a.wrapLink')[0]
      wrapLink.href = wrapLink.href.replace('main.php','')
      const catetitle = $('.catetitle a',v)[0]

      // ボタン挿入
      if(catetitle!=undefined){
        $(`<a href="${catetitle.href.replace('main.php','')}" class="catbtn button button-small button-secondary">${catetitle.innerHTML}</a>`).insertAfter( $('.cover-thumb',v) )
      }

      // デフォルト表示カテゴリ名を削除
      $('.catetitle',v).remove()

    })

  })
}